import React from 'react';
import Script from 'next/script';
import { useStore, observer } from 'base/store';
import site from 'pro/config/site';

const RiskifiedBeacon: React.FC = observer(() => {
    const { userStore, rootStore } = useStore();
    return !userStore.state?.loginToken || ['dev', 'test'].includes(rootStore.state.envName) ? null : (
        <Script
            id="riskified"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
                __html: `(function() {
                        function riskifiedBeaconLoad() {
                            console.log("----- riskified Beacon Load -----")
                            
                            var session_id = '${userStore.state?.loginToken}';
                            var store_domain = '${site.domain}';
                            var url = ('https:' == document.location.protocol ? 'https://' : 'http://')
                                + "beacon.riskified.com?shop=" + store_domain + "&sid=" + session_id;
                            var s = document.createElement('script');
                            s.type = 'text/javascript';
                            s.async = true;
                            s.src = url;
                            var x = document.getElementsByTagName('script')[0];
                            x.parentNode.insertBefore(s, x);
                        }
                        if (document.readyState=="complete") {
                            riskifiedBeaconLoad()
                        } else {
                            if (window.attachEvent) {
                                window.attachEvent('onload', riskifiedBeaconLoad)
                            } else {
                                window.addEventListener('load', riskifiedBeaconLoad, false);
                            }
                        }
                    })();`,
            }}
        />
    )
})

export default React.memo(RiskifiedBeacon);
